import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCMS } from '../context/CMSContext';
import DefaultTemplate from '../templates/DefaultTemplate';
import OtpTemplate from '../templates/OtpTemplate';
import BookingTemplate from '../templates/BookingTemplate';
import MinimalTemplate from '../templates/MinimalTemplate';
import KwikFormTemplate from '../templates/KwikFormTemplate';
import NotFoundPage from './NotFoundPage';

const formatTitleFromSlug = (slug) => {
  if (!slug || typeof slug !== 'string') return 'Landing Page';
  const suffix = slug.includes('-lp-') ? slug.split('-lp-').slice(1).join('-lp-') : slug;
  const normalized = suffix.replace(/[-_]+/g, ' ').trim();
  if (!normalized) return 'Landing Page';
  return normalized
    .split(' ')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const isLpSlug = (slug) => typeof slug === 'string' && /(^|-)lp(-|$)/.test(slug);

const HomePage = () => {
  const params = useParams();
  const slug = params['*'];
  const { data, activeTemplate, setActivePage, loading, pageLoading, hasError, activePageSlug, isPageContentLoaded, pageNotFound } = useCMS();

  const currentSlug = (slug || '').replace(/\/$/, '').trim() || 'home';

  useEffect(() => {
    if (loading || hasError) return;
    setActivePage(currentSlug);
  }, [currentSlug, setActivePage, loading, hasError]);

  // 404 comes from the page's own fetch — the page index is admin-only now, so
  // there is no local list to check a slug against. Auto-creation is disabled.
  if (pageNotFound && !hasError) {
    return <NotFoundPage />;
  }

  if (loading || pageLoading || activePageSlug !== currentSlug || !isPageContentLoaded) {

    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-4">
        <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
        <div className="text-xl font-semibold text-gray-400">
          {hasError ? 'Difficulty reaching server. Trying local data...' : 'Loading Page Data...'}
        </div>
        {hasError && (
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-bold"
          >
            Retry Update
          </button>
        )}
      </div>
    );
  }

  const renderTemplate = () => {
    switch (activeTemplate) {
      case 'minimal':
        return <MinimalTemplate />;
      case 'otp':
        return <OtpTemplate />;
      case 'booking':
        return <BookingTemplate />;
      case 'kwikform':
        return <KwikFormTemplate />;
      case 'default':
      default:
        return <DefaultTemplate />;
    }
  };

  return renderTemplate();
};

export default HomePage;
